import React, { useCallback, useEffect, useState, useRef, useMemo } from "react";
import "../eventcategorylist/EventCategoryList.css";
import "../events/Events.css";
import Navbar from "../common-component/navbar/Navbar";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import useEmirateFromCoordinates, { BACKEND_URL } from "../common/Common";
import axios from "axios";
import Slider from "react-slick";
import leftarrow from '../../assets/offers/leftarrow.png';
import search from '../../assets/home-images/search.png';
import filtericon from '../../assets/categorylist/filtericon.png';

import omanflag from '../../assets/experience/omanflag.png';
import qatarflag from '../../assets/experience/qatarflag.png';
import kuwaitflag from '../../assets/experience/kuwaitflag.png';
import ksaflag from '../../assets/experience/ksaflag.png';
import flagicon from '../../assets/home-images/flagicon.png';
import xmark from '../../assets/home-images/right-section-images/xmark.png';
import downarrow from '../../assets/home-images/downarrow.png';

import eventbanner from '../../assets/experience/Eventbanner.png';
import menuicon from '../../assets/categorylist/menuicon.png';
import vertical_line from '../../assets/categorylist/vertical_line.png';
import rightarrow from '../../assets/home-images/right-section-images/rightarrow.png';
import downarrowicon from '../../assets/categorylist/downarrowicon.png';

import locationPinblack from "../../assets/events/locationpin.png";
import nodata from '../../assets/experience/nodata.png';
import datepicker from "../../assets/event-details/Datepicker.png";
import popup_yatch from "../../assets/offers/popup_yatch.png";
import hayatlogo from '../../assets/home-images/right-section-images/hayatlogo.png';
import qr from '../../assets/home-images/right-section-images/qr.png';
import app_store from '../../assets/home-images/right-section-images/app_store.png';
import play_store from '../../assets/home-images/right-section-images/play_store.png';
import bluexmark from '../../assets/business and brands/bluexmark.png';

import liveconcert from "../../assets/events/liveconcert.png";
import food_dining from "../../assets/events/food_dining.png";
import culture_exhibition from "../../assets/events/culture_exhibition.png";
import sports from "../../assets/events/sports.png";
import kids from "../../assets/events/kids.png";
import networking from "../../assets/events/networking.png";
import communityandsocial from "../../assets/events/communityandsocial.png";
import wellness from "../../assets/events/wellness.png";
import eventsnightlife from "../../assets/events/eventsnightlife.png";

const countryicons = [omanflag, qatarflag, kuwaitflag, ksaflag]

// Debounce utility
const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

const EventCategoryList = () => {
    const { eventcategoryId } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const urlType = searchParams.get('type'); // 'events' or 'vendors'
    const [searchTerm, setSearchTerm] = useState("");
    const [filtepopup, setFilterpopup] = useState(false);
    const [countrypopup, setCountrypopup] = useState(false);
    const [states, setStates] = useState([]);
    const [eventcategory, setEventCategory] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [showSubcategories, setShowSubcategories] = useState(false);
    const [showDateFilters, setShowDateFilters] = useState(false);
    const [showEventTypes, setShowEventTypes] = useState(false);
    const [showEventCategories, setShowEventCategories] = useState(true);
    const [selectedSubcategories, setSelectedSubcategories] = useState([]);
    const [selectedEventTypes, setSelectedEventTypes] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [expandedCategories, setExpandedCategories] = useState({});
    const [categoryName, setCategoryName] = useState("");
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [selectedStateId, setSelectedStateId] = useState(null);
    const [selectedStateName, setSelectedStateName] = useState("Abu Dhabi");
    const emirate = useEmirateFromCoordinates(latitude, longitude);
    const [eventlist, setEventList] = useState([]);
    const [isEventListLoading, setIsEventListLoading] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const endDateInputRef = useRef(null);
    const [sponsorbannereventlist, setSponsorBannerEventList] = useState([]);
    const [sponsorbanner, setSponsorBanner] = useState([]);
    const [categorybanner, setCategoryBanner] = useState([]);
    const [categorybannereventlist, setCategoryBannerEventList] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
    const categorySliderRef = useRef(null);
    const [categorySlides, setCategorySlides] = useState(() => {
        const width = window.innerWidth;
        if (width >= 1441) return 4;
        if (width >= 1092) return 3; // 1092px and above
        if (width >= 1024 && width <= 1091) return 2.5; // Specific range 1025-1091px
        if (width >= 769 && width <= 1023) return 3;
        if (width >= 320 && width <= 768) return 1.5;
        return 1;
    });
    const [activeTab, setActiveTab] = useState("nearme"); // nearme or following
    const [showDownloadPopup, setShowDownloadPopup] = useState(false);
    const [isNearMeActive, setIsNearMeActive] = useState(false);

    // Category images array
    const categoryImagesArray = [
        liveconcert,
        food_dining,
        culture_exhibition,
        sports,
        kids,
        networking,
        communityandsocial,
        wellness,
        eventsnightlife,
    ];

    // Helper function to get category image based on index
    const getCategoryImage = (category, index) => {
        return categoryImagesArray[index % categoryImagesArray.length] || liveconcert;
    };

    const PrevArrow = ({ onClick }) => (
        <div className="custom-arrow prev-arrow" onClick={onClick}>
            <img src={leftarrow} alt="Previous" className="event-category-prev-arrow" />
        </div>
    );

    const NextArrow = ({ onClick }) => (
        <div className="custom-arrow next-arrow" onClick={onClick}>
            <img src={rightarrow} alt="Next" className="event-category-next-arrow" />
        </div>
    );

    // Category slider settings
    const categorySliderSettings = useMemo(() => ({
        infinite: false,
        speed: 500,
        slidesToShow: categorySlides,
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        arrows: categorySlides >= 2.5, // arrows for 2.5+ slides (desktop and tablet)
        swipeToSlide: true,
        centerMode: false,
        variableWidth: true, // Add this
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
    }), [categorySlides]);

    // Scroll to selected category when eventcategoryId changes
    useEffect(() => {
        if (eventcategoryId && categorySliderRef.current && Array.isArray(eventcategory) && eventcategory.length > 0) {
            const selectedIndex = eventcategory.findIndex(
                cat => Number(cat.id) === Number(eventcategoryId)
            );

            if (selectedIndex !== -1 && categorySliderRef.current.slickGoTo) {
                // Use setTimeout to ensure slider is initialized
                setTimeout(() => {
                    categorySliderRef.current?.slickGoTo(selectedIndex);
                }, 100);
            }
        }
    }, [eventcategoryId, eventcategory]);

    // Reinitialize slider position when categorySlides changes (e.g., on resize/DevTools open)
    useEffect(() => {
        if (eventcategoryId && categorySliderRef.current && Array.isArray(eventcategory) && eventcategory.length > 0) {
            const selectedIndex = eventcategory.findIndex(
                cat => Number(cat.id) === Number(eventcategoryId)
            );

            if (selectedIndex !== -1 && categorySliderRef.current.slickGoTo) {
                // Use setTimeout to ensure slider is reinitialized after key change
                const timeoutId = setTimeout(() => {
                    categorySliderRef.current?.slickGoTo(selectedIndex);
                }, 150);

                return () => clearTimeout(timeoutId);
            }
        }
    }, [categorySlides, eventcategoryId, eventcategory]);

    // Handle resize for mobile detection and category slides
    useEffect(() => {
        const handleResize = debounce(() => {
            setIsMobile(window.innerWidth <= 1024);
            const width = window.innerWidth;
            if (width >= 1441) setCategorySlides(4);
            else if (width >= 1092) setCategorySlides(3); // 1092px and above
            else if (width >= 1024 && width <= 1091) setCategorySlides(2.5); // Specific range 1025-1091px
            else if (width >= 769 && width <= 1023) setCategorySlides(3);
            else if (width >= 320 && width <= 768) setCategorySlides(1.5);
            else setCategorySlides(1);
        }, 150);

        // Immediately set correct value in case dev tools changed width before render
        handleResize();

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleSearchChange = useCallback((e) => {
        setSearchTerm(e.target.value);
    }, []);

    const toggleSubcategories = useCallback(() => {
        setShowSubcategories(prev => !prev);
    }, []);

    const toggleDateFilters = useCallback(() => {
        setShowDateFilters(prev => !prev);
    }, []);

    const toggleEventTypes = useCallback(() => {
        setShowEventTypes(prev => !prev);
    }, []);

    const toggleEventCategories = useCallback(() => {
        setShowEventCategories(prev => !prev);
    }, []);

    const toggleCategoryExpansion = useCallback((categoryId) => {
        setExpandedCategories(prev => ({
            ...prev,
            [categoryId]: !prev[categoryId]
        }));
    }, []);

    const handleCategoryChange = useCallback((e, categoryId) => {
        const id = Number(categoryId);
        if (e.target.checked) {
            setSelectedCategories(prev => [...prev, id]);
        } else {
            setSelectedCategories(prev => prev.filter(catId => catId !== id));
            // Also remove subcategories of this category when category is unchecked
            const category = eventcategory.find(cat => Number(cat.id) === id);
            if (category && Array.isArray(category.subcategories)) {
                const subIds = category.subcategories.map(sub => Number(sub.id));
                setSelectedSubcategories(prev => prev.filter(subId => !subIds.includes(subId)));
            }
        }
    }, [eventcategory]);

    const handleSubcategoryChange = useCallback((e, subcategoryId) => {
        const id = Number(subcategoryId);
        if (e.target.checked) {
            setSelectedSubcategories(prev => [...prev, id]);
        } else {
            setSelectedSubcategories(prev => prev.filter(subId => subId !== id));
        }
    }, []);

    const handleEventTypeChange = useCallback((e, eventType) => {
        const type = Number(eventType);
        if (e.target.checked) {
            setSelectedEventTypes(prev => [...prev, type]);
        } else {
            setSelectedEventTypes(prev => prev.filter(t => t !== type));
        }
    }, []);

    const handleShowResult = async () => {
        setFilterpopup(false);
        if (latitude !== null && longitude !== null) {
            // Don't call fetcheventlist if this is a sponsor banner or category banner event list
            if ((urlType !== 'events' && urlType !== 'categorybanner') || !eventcategoryId) {
                // Always call API with current filters (categories, subcategories, dates, event types, and search)
                await fetcheventlist(selectedSubcategories, searchTerm.trim(), selectedEventTypes, selectedCategories);
            }
            // Note: For sponsor banner and category banner events, filters are handled client-side (see display logic below)
        }
    };

    const handleClearAll = () => {
        setSelectedCategories([]);
        setSelectedSubcategories([]);
        setSelectedEventTypes([]);
        setStartDate("");
        setEndDate("");
    };

    const handleStartDateChange = (e) => {
        const selectedDate = e.target.value;
        setStartDate(selectedDate);
    };

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
        // The useEffect will handle the API call when both dates are set
    };

    const handleClearDates = () => {
        setStartDate("");
        setEndDate("");
    };

    // Handle Near Me toggle
    const handleNearMeToggle = () => {
        const newNearMeState = !isNearMeActive;
        setIsNearMeActive(newNearMeState);

        // Refetch event list with near_me parameter
        if (latitude !== null && longitude !== null) {
            // Don't call fetcheventlist if this is a sponsor banner or category banner event list
            if ((urlType !== 'events' && urlType !== 'categorybanner') || !eventcategoryId) {
                fetcheventlist(selectedSubcategories, searchTerm.trim(), selectedEventTypes, selectedCategories);
            }
        }
    };

    // Handle Near Me remove (when X is clicked)
    const handleNearMeRemove = () => {
        setIsNearMeActive(false);

        // Refetch event list without near_me parameter
        if (latitude !== null && longitude !== null) {
            // Don't call fetcheventlist if this is a sponsor banner or category banner event list
            if ((urlType !== 'events' && urlType !== 'categorybanner') || !eventcategoryId) {
                fetcheventlist(selectedSubcategories, searchTerm.trim(), selectedEventTypes, selectedCategories);
            }
        }
    };

    const handleStateClick = useCallback((state) => {
        setSelectedStateId(state.id);
        setSelectedStateName(state.name || "Abu Dhabi");

        // Get coordinates from state, with defaults
        const lat = parseFloat(state.latitude || state.lat || 24.4539);
        const lng = parseFloat(state.longitude || state.lng || 54.3773);

        // Store selected state in localStorage
        localStorage.setItem('selectedState', JSON.stringify({
            id: state.id,
            name: state.name,
            latitude: lat,
            longitude: lng
        }));

        // Always update coordinates (use defaults if state doesn't have them)
        setLatitude(lat);
        setLongitude(lng);

        setCountrypopup(false);
    }, []);


    const fetchMasterData = async () => {
        try {
            const response = await axios.get(`${BACKEND_URL}website/get-master-data`);
            if (response.data.stateData) {
                setStates(response.data.stateData);
            } else {
                setStates([]);
            }
        } catch (error) {
            console.error("Error fetching master data:", error);
        }
    };
    const fetcheventcategory = async () => {
        try {
            const response = await axios.get(`${BACKEND_URL}website/get-event-category`);
            setEventCategory(response.data);
            // Debug: Log category names to help identify mapping issues

        } catch (error) {
            console.error("Error fetching Events Category :", error);
        }
    }

    const fetcheventlist = async (subcategoryIds = [], search = "", eventTypes = [], categoryIds = []) => {
        // Only proceed if we have coordinates
        if (latitude === null || longitude === null) {
            console.log("Waiting for coordinates...");
            return;
        }

        setIsEventListLoading(true);

        // Ensure subcategoryIds is an array of numbers (remove duplicates and invalid values)
        const subcategoryIdArray = Array.isArray(subcategoryIds)
            ? [...new Set(subcategoryIds.map(id => Number(id)).filter(id => !isNaN(id) && id > 0))]
            : [];

        // Ensure eventTypes is an array of numbers (0 or 1)
        const eventTypeArray = Array.isArray(eventTypes)
            ? [...new Set(eventTypes.map(t => Number(t)).filter(t => !isNaN(t) && (t === 0 || t === 1)))]
            : [];

        // Ensure categoryIds is an array of numbers
        const categoryIdArray = Array.isArray(categoryIds)
            ? [...new Set(categoryIds.map(id => Number(id)).filter(id => !isNaN(id) && id > 0))]
            : [];

        const payload = {
            login_user_id: 313,
            latitude: latitude || 24.4882047,
            longitude: longitude || 54.3729757,
            state_id: selectedStateId || emirate?.id || "",
            user_id: "",
            near_me: isNearMeActive ? true : "",
        };

        // Only include category_id if eventcategoryId is provided (from URL) AND it's NOT a banner ID (type != 'events')
        // If type='events', eventcategoryId is actually a banner ID, not a category ID
        if (urlType !== 'events' && eventcategoryId && categoryIdArray.length === 0) {
            // Use URL category ID only if no categories selected from filter AND it's not a banner ID
            payload.category_id = eventcategoryId;
        } else if (categoryIdArray.length > 0) {
            // If categories are selected from filter, use those instead
            payload.category_id = JSON.stringify(categoryIdArray);
        }

        // Add search parameter if provided
        if (search && search.trim()) {
            payload.search = search.trim();
        }

        // Only include subcategory_id if there are selected subcategories
        // Backend expects subcategory_id as a JSON string, not an array
        if (subcategoryIdArray.length > 0) {
            payload.subcategory_id = JSON.stringify(subcategoryIdArray);
        }

        // Add event_type if there are selected event types (but not if both are selected - that means show all)
        if (eventTypeArray.length > 0 && eventTypeArray.length < 2) {
            // Only send filter if one type is selected (0 or 1)
            // If both are selected, don't send filter (show all events)
            payload.event_type = JSON.stringify(eventTypeArray);
        }

        // Add start_date and end_date if they are selected
        // HTML date input already provides YYYY-MM-DD format, send as-is to backend
        if (startDate) {
            payload.start_date = startDate; // YYYY-MM-DD format
        }
        if (endDate) {
            payload.end_date = endDate; // YYYY-MM-DD format
        }
        console.log(payload);
        

        try {
            const response = await axios.post(`${BACKEND_URL}website/get-event-list`, payload);
            setEventList(response.data || []);
        } catch (error) {
            console.error("Error fetching Events List:", error);
            console.error("Error details:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
            setEventList([]);
        } finally {
            setIsEventListLoading(false);
        }

    }

    const formatDate = (dateStr) => {
        if (!dateStr) return "";

        const [day, month, year] = dateStr.split("-");
        const date = new Date(year, month - 1, day);

        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    const fetchsponsorbanner = async () => {
        try {
            const response = await axios.post(`${BACKEND_URL}website/get-sponsor-banner`);
            setSponsorBanner(response.data);
        } catch (error) {
            console.error("Error fetching Sponsor Banners:", error);
        }
    }

    const fetchsponsorbannereventlist = async (bannerId) => {
        if (!bannerId) {
            console.log("Sponsor banner Id not available");
            return;
        }
        setIsEventListLoading(true);
        const payload = {
            banner_id: bannerId,
            login_user_id: 501,
        }

        try {
            const response = await axios.post(`${BACKEND_URL}website/get-sponsor-banner-event-list`, payload);
            setSponsorBannerEventList(response.data || []);

        } catch (error) {
            console.log("Error Fetching Sponsor Banner Event List:", error);
            setSponsorBannerEventList([]);
        } finally {
            setIsEventListLoading(false);
        }
    }

    const fetchcategorybanner = async () => {
        try {
            const response = await axios.post(`${BACKEND_URL}website/get-category-banner`);
            setCategoryBanner(response.data);
        } catch (error) {
            console.error("Error fetching Category Banners:", error);
        }
    }


    const fetchcategorybannereventlist = async (bannerId) => {
        if (!bannerId) {
            console.log("Sponsor banner Id not available");
            return;
        }
        setIsEventListLoading(true);
        const payload = {
            banner_id: bannerId,
            login_user_id: 501,
        }
        console.log(payload);

        try {
            const response = await axios.post(`${BACKEND_URL}website/get-category-banner-event-list`, payload);
            setCategoryBannerEventList(response.data || []);
            console.log(response.data);

        } catch (error) {
            console.log("Error Fetching Sponsor Banner Event List:", error);
            setCategoryBannerEventList([]);
        } finally {
            setIsEventListLoading(false);
        }
    }


    useEffect(() => {
        // Check for stored state in localStorage first
        const storedState = localStorage.getItem('selectedState');
        if (storedState) {
            try {
                const state = JSON.parse(storedState);
                setSelectedStateId(state.id);
                setSelectedStateName(state.name || "Abu Dhabi");
                if (state.latitude) {
                    setLatitude(parseFloat(state.latitude));
                } else {
                    setLatitude(24.4539); // Default if no latitude in stored state
                }
                if (state.longitude) {
                    setLongitude(parseFloat(state.longitude));
                } else {
                    setLongitude(54.3773); // Default if no longitude in stored state
                }
            } catch (error) {
                console.error("Error parsing stored state:", error);
                // Set defaults on error
                setLatitude(24.4539);
                setLongitude(54.3773);
                setSelectedStateName("Abu Dhabi");
            }
        } else {
            // If no stored state, set defaults immediately and try geolocation
            setLatitude(24.4539);
            setLongitude(54.3773);
            setSelectedStateName("Abu Dhabi");

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        setLatitude(position.coords.latitude);
                        setLongitude(position.coords.longitude);
                    },
                    (error) => {
                        console.error("Error getting location:", error);
                        // Defaults already set above
                    }
                );
            }
        }
    }, []);

    useEffect(() => {
        fetchMasterData();
        fetcheventcategory();
        fetchsponsorbanner();
        fetchcategorybanner();

    }, []);

    // Initial load and when coordinates/emirate change (don't auto-trigger on filter changes)
    // Skip if this is a sponsor banner or category banner event list
    useEffect(() => {
        if (latitude !== null && longitude !== null) {
            // Don't call fetcheventlist if this is a sponsor banner or category banner event list
            if ((urlType !== 'events' && urlType !== 'categorybanner') || !eventcategoryId) {
                fetcheventlist([], searchTerm.trim(), [], []);
            }
        }
    }, [latitude, longitude, emirate, urlType, eventcategoryId, selectedStateId, isNearMeActive])

    // Debounced search effect - only triggers when searchTerm changes
    // Note: This will auto-trigger on search, but filters require "Show Result" button
    // Skip if this is a sponsor banner or category banner event list
    useEffect(() => {
        if (latitude === null || longitude === null) {
            return;
        }

        // Don't call fetcheventlist if this is a sponsor banner or category banner event list
        if ((urlType === 'events' || urlType === 'categorybanner') && eventcategoryId) {
            return;
        }

        // Debounce the API call
        const timeoutId = setTimeout(() => {
            fetcheventlist(selectedSubcategories, searchTerm.trim(), selectedEventTypes, selectedCategories);
        }, 500); // 500ms debounce delay

        return () => clearTimeout(timeoutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm, urlType, eventcategoryId]);

    // Date filter effect - triggers when endDate is selected (both dates are set)
    // This ensures API is called immediately after user selects end date
    useEffect(() => {
        // Skip if coordinates are not available
        if (latitude === null || longitude === null) {
            return;
        }

        // Don't call fetcheventlist if this is a sponsor banner or category banner event list
        if ((urlType === 'events' || urlType === 'categorybanner') && eventcategoryId) {
            return;
        }

        // Trigger when endDate is set and startDate already exists (both dates are selected)
        // This will trigger when user selects end date after start date
        if (endDate && startDate && endDate.trim() !== "" && startDate.trim() !== "" && endDate.includes("-") && startDate.includes("-")) {
            // Call API immediately when end date is selected
            fetcheventlist(selectedSubcategories, searchTerm.trim(), selectedEventTypes, selectedCategories);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [endDate]); // Only depend on endDate - triggers when end date is selected



    // Get subcategories and category name for the selected event category
    useEffect(() => {
        if (eventcategoryId && Array.isArray(eventcategory) && eventcategory.length > 0) {
            const selectedCategory = eventcategory.find(
                cat => Number(cat.id) === Number(eventcategoryId)
            );

            if (selectedCategory) {
                // Set category name
                if (selectedCategory.category_name) {
                    setCategoryName(selectedCategory.category_name);
                }

                // Set subcategories
                if (Array.isArray(selectedCategory.subcategories)) {
                    setSubcategories(selectedCategory.subcategories);
                } else {
                    setSubcategories([]);
                }
            } else {
                setCategoryName("");
                setSubcategories([]);
            }
        } else {
            setCategoryName("");
            setSubcategories([]);
        }
    }, [eventcategoryId, eventcategory]);

    // Auto-expand subcategories section when a category is selected
    useEffect(() => {
        if (eventcategoryId && urlType !== 'events' && urlType !== 'categorybanner') {
            // Auto-expand the Event Categories section when a specific category is selected
            setShowEventCategories(true);
        }
    }, [eventcategoryId, urlType]);

    useEffect(() => {
        // If type=categorybanner is in URL, use eventcategoryId as banner ID for category banner
        if (urlType === 'categorybanner' && eventcategoryId) {
            // eventcategoryId is actually the banner ID when type=categorybanner
            console.log("Fetching category banner events for banner ID:", eventcategoryId);
            fetchcategorybannereventlist(eventcategoryId);
        } else if (urlType === 'events' && eventcategoryId) {
            // eventcategoryId is actually the banner ID when type=events
            console.log("Fetching sponsor banner events for banner ID:", eventcategoryId);
            fetchsponsorbannereventlist(eventcategoryId);
        } else if (sponsorbanner && sponsorbanner.length > 0 && sponsorbanner[0]?.id) {
            // Normal flow - use first sponsor banner
            console.log("Fetching sponsor banner events for banner ID:", sponsorbanner[0].id);
            fetchsponsorbannereventlist(sponsorbanner[0].id);
        }
    }, [sponsorbanner, urlType, eventcategoryId])

    // Handler for location change from Navbar hamburger menu
    const handleNavbarStateChange = useCallback((state) => {
        handleStateClick(state);
    }, [handleStateClick]);

    // Prepare selectedState object for Navbar
    const selectedStateForNavbar = useMemo(() => {
        if (selectedStateId && states.length > 0) {
            const state = states.find(s => Number(s.id) === Number(selectedStateId));
            if (state) {
                return {
                    id: state.id,
                    name: state.name || selectedStateName,
                    latitude: latitude,
                    longitude: longitude
                };
            }
        }
        return {
            id: selectedStateId,
            name: selectedStateName,
            latitude: latitude,
            longitude: longitude
        };
    }, [selectedStateId, selectedStateName, latitude, longitude, states]);

    return (
        <div>
            <Navbar
                showLocationSelector={true}
                states={states}
                selectedState={selectedStateForNavbar}
                onStateChange={handleNavbarStateChange}
            />
            <div className="mobile-category-header">
                <div className="mobile-header-top">
                    <div className="mobile-category-title">
                        <img src={leftarrow} alt="back" className="mobile-back-icon" onClick={() => navigate(-1)} />
                        {(urlType === 'events' || urlType === 'categorybanner') && eventcategoryId ? (
                            <h4><span></span> Events</h4>
                        ) : categoryName ? (
                            <h4><span>Events /</span> {categoryName}</h4>
                        ) : (
                            <h4><span>Events /</span> All Events</h4>
                        )}
                    </div>
                    {/* <div className="mobile-location-dropdown" onClick={() => setCountrypopup(true)}>
                                    <img src={flagicon} alt="flag" className="mobile-flag-icon" />
                                    <span>Abu Dhabi</span>
                                    <img src={downarrowicon} alt="dropdown" className="mobile-dropdown-icon" />
                                </div> */}
                </div>
                <div className="mobile-search-filter-container">
                    <div className="mobile-searchbox">
                        <img src={search} alt="search" />
                        <input
                            type="text"
                            placeholder="Search events..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                    </div>
                    <img
                        src={filtericon}
                        alt="filter"
                        className="mobile-filter-icon"
                        onClick={() => setFilterpopup(true)}
                    />
                </div>
                
            </div>
            <div className="experience-main-layout category-list-page-main-layout event-category-list-page-main-layout">
                <aside className="left-section">
                    <div className="searchbox">
                        <img src={search} alt="search" />
                        <input
                            type="text"
                            placeholder="Search Events..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                    </div>
                    <div className="left-menu-content">

                        <div className="img-contentname" onClick={() => setCountrypopup(true)} >
                            <img src={flagicon} alt="flag" className="flagicon" />
                            <p>{selectedStateName}</p>
                        </div>
                    </div>
                    <div className="divider-line"></div>
                    <div className="left-bottom-links">
                        <div className="left-bottom1">
                            <a href="/about">About</a>
                            {/* <a href="#BusinessPro">Business Pro</a> */}
                            <div className="content-arrow">
                                <Link to="/merchantagreement" className="privacy-link">
                                    <span>Privacy & Terms</span>
                                    <img src={downarrow} alt="down arrow" />
                                </Link>
                            </div>
                        </div>

                        {/* Uncomment these sections when you need them */}
                        {/* 
                            <div className="left-bottom1">
                                <a href="#help-center">Help Center</a>
                                <a href="#FAQ">FAQ</a>
                                <a href="#Careers">Careers</a>
                            </div>
                            <div className="left-bottom1">
                                <div className="content-arrow">
                                    <Link to="/merchantagreement" className="privacy-link">
                                        <span>Privacy & Terms</span>
                                        <img src={downarrow} alt="down arrow" />
                                    </Link>
                                </div>
                                <div className="content-arrow">
                                    <a href="#Languages">Language</a>
                                    <img src={downarrow} alt="downarrow" />
                                </div>
                            </div>
                        */}
                    </div>
                </aside>

                <main className="experience-middle-section">
                    <div className="mid-section-head-div">
                        <img src={eventbanner} alt="enjoy summer" className="enjoy-summer-img" />
                    </div>

                    {/* Categories Carousel - Hide when navigating from banner clicks */}
                    {(urlType !== 'events' && urlType !== 'categorybanner') && (
                        <div className="events-categories-section event-category-list-page">
                            <h6 className="events-categories-heading">Categories</h6>
                            <div className="events-categories-slider-container">
                                <Slider
                                    ref={categorySliderRef}
                                    key={`category-slider-${isMobile ? "mobile" : "desktop"}-${categorySlides}`}
                                    {...categorySliderSettings}
                                    className="events-categories-carousel"
                                >
                                    {eventcategory.map((category, index) => {
                                        const isSelected = eventcategoryId && Number(category.id) === Number(eventcategoryId);
                                        return (
                                            <Link
                                                key={category.id}
                                                to={`/eventcategorylist/${category.id}`}
                                                className="remove-underline"
                                            >
                                                <div className="events-category-slide">
                                                    <div
                                                        className="events-category-card"
                                                        style={{
                                                            backgroundColor: isSelected ? '#DBE8FF' : '#F4F8FF'
                                                        }}
                                                    >
                                                        <div className="events-category-image-wrapper">
                                                            <img
                                                                src={getCategoryImage(category, index)}
                                                                alt={category.category_name}
                                                                className="events-category-image"
                                                            />
                                                        </div>
                                                        <p className="events-category-label">
                                                            {category.category_name}
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        );
                                    })}
                                </Slider>
                            </div>
                        </div>
                    )}

                    {/* Near Me / Following Section - Desktop */}
                    <div className="business-brands-nearme-following-category-div for-event-category-list">
                        {isNearMeActive ? (
                            <div className="near-me-filter-tag" onClick={handleNearMeRemove}>
                                <span>Near me</span>
                                <img
                                    src={bluexmark}
                                    alt="remove"
                                    className="near-me-remove-icon"
                                />
                            </div>
                        ) : (
                            <p onClick={handleNearMeToggle}>Near me</p>
                        )}
                        <p onClick={() => setShowDownloadPopup(true)}>Following</p>
                    </div>

                    <div className="categorylist-wrapper">
                        <div className="categorylist-section">
                            <div className="event-date-filters">
                                <p className="start-end-date">Start Date</p>
                                <div className="date-input-wrapper">
                                    <img src={datepicker} alt="date selector" className="datepicker" />
                                    <input
                                        type="date"
                                        className="date-input"
                                        value={startDate}
                                        onChange={handleStartDateChange}
                                    />
                                    {!startDate && <span className="date-placeholder">DD/MM/YYYY</span>}
                                </div>
                                <span>- </span>
                                <p className="start-end-date">End Date</p>
                                <div className="date-input-wrapper">
                                    <img src={datepicker} alt="date selector" className="datepicker" />

                                    <input
                                        ref={endDateInputRef}
                                        type="date"
                                        className="date-input"
                                        value={endDate}
                                        onChange={handleEndDateChange}
                                    />
                                    {!endDate && <span className="date-placeholder">DD/MM/YYYY</span>}
                                </div>
                                {(startDate || endDate) && (
                                    <button className="clear-date-btn" onClick={handleClearDates}>
                                        Clear
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="category-list-menu-filter-div">
                            <div className="menu-map-filter-div">
                                <img src={menuicon} alt="menu icon" className="menu-icon" />
                                {/* <img src={mapicon} alt="map icon" className="map-icon" /> */}
                                <img src={vertical_line} alt="vertical line" className="vertical-line" />
                                <img src={filtericon} alt="filter icon" className="filter-icon" onClick={() => setFilterpopup(true)} />
                            </div>
                        </div>
                    </div>

                    {/* <div className="category-title catgeory-list-page">
                        {(urlType === 'events' || urlType === 'categorybanner') && eventcategoryId ? (
                            <h6><span></span> Events</h6>
                        ) : categoryName ? (
                            <h6><span>Events /</span> {categoryName}</h6>
                        ) : (
                            <h6><span>Events /</span> All Events</h6>
                        )}
                    </div> */}

                    <div className="offers-grid-container category-list-page">
                        {isEventListLoading ? (
                            // Shimmer loading skeleton
                            Array.from({ length: 6 }).map((_, index) => (
                                <div key={`shimmer-${index}`} className="offer-card shimmer-card">
                                    <div className="offer-img-wrapper shimmer-image"></div>
                                    <div className="offer-details">
                                        <div className="shimmer-line shimmer-location"></div>
                                        <div className="shimmer-line shimmer-title"></div>
                                        <div className="shimmer-line shimmer-subtitle"></div>
                                        <div className="shimmer-line shimmer-price"></div>
                                    </div>
                                </div>
                            ))
                        ) : (() => {
                            // Determine which event list to display
                            // If urlType === 'categorybanner' and eventcategoryId exists, use category banner event list
                            // If urlType === 'events' and eventcategoryId exists, use sponsor banner event list
                            // Otherwise, use regular event list
                            const displayList = (urlType === 'categorybanner' && eventcategoryId)
                                ? categorybannereventlist
                                : (urlType === 'events' && eventcategoryId)
                                    ? sponsorbannereventlist
                                    : eventlist;

                            // Apply client-side filtering for sponsor banner and category banner events
                            let filteredList = Array.isArray(displayList) ? [...displayList] : [];

                            if ((urlType === 'events' || urlType === 'categorybanner') && eventcategoryId && filteredList.length > 0) {
                                // Apply search filter
                                if (searchTerm.trim()) {
                                    const searchLower = searchTerm.trim().toLowerCase();
                                    filteredList = filteredList.filter(item =>
                                        item.title?.toLowerCase().includes(searchLower) ||
                                        item.location_name?.toLowerCase().includes(searchLower)
                                    );
                                }

                                // Apply date filters
                                if (startDate || endDate) {
                                    filteredList = filteredList.filter(item => {
                                        if (!item.start_date) return false;
                                        const [day, month, year] = item.start_date.split("-");
                                        const eventDate = new Date(year, month - 1, day);

                                        if (startDate) {
                                            const [sdDay, sdMonth, sdYear] = startDate.split("-");
                                            const startDateObj = new Date(sdYear, sdMonth - 1, sdDay);
                                            if (eventDate < startDateObj) return false;
                                        }

                                        if (endDate) {
                                            const [edDay, edMonth, edYear] = endDate.split("-");
                                            const endDateObj = new Date(edYear, edMonth - 1, edDay);
                                            if (eventDate > endDateObj) return false;
                                        }

                                        return true;
                                    });
                                }

                                // Apply event type filter
                                if (selectedEventTypes.length > 0 && selectedEventTypes.length < 2) {
                                    filteredList = filteredList.filter(item => {
                                        const eventType = Number(item.event_type);
                                        return selectedEventTypes.includes(eventType);
                                    });
                                }

                                // Apply category/subcategory filters (if applicable)
                                if (selectedCategories.length > 0 || selectedSubcategories.length > 0) {
                                    filteredList = filteredList.filter(item => {
                                        if (selectedSubcategories.length > 0) {
                                            return selectedSubcategories.includes(Number(item.subcategory_id));
                                        }
                                        if (selectedCategories.length > 0) {
                                            return selectedCategories.includes(Number(item.category_id));
                                        }
                                        return true;
                                    });
                                }
                            }

                            return Array.isArray(filteredList) && filteredList.length > 0 ? (
                                filteredList.map((item, index) => (
                                    <Link
                                        key={`event-${item.event_id}-${index}`}
                                        to={`/eventdetails/${item.event_id}`}
                                        className="remove-underline"
                                    >
                                        <div className="offer-card">
                                            <div className="offer-img-wrapper">
                                                <img src={item.event_image} alt="festive season" />
                                            </div>
                                            <div className="offer-details">
                                                <p className="offer-location">
                                                    <span>
                                                        <img src={locationPinblack} alt="logo" className="locationpinicon" />
                                                    </span>
                                                    <span>{item.location_name}</span>
                                                </p>
                                                <h4>{item.title}</h4>
                                                <p className="limited-deals-distance">
                                                    {item.start_date === item.end_date
                                                        ? formatDate(item.start_date)
                                                        : `${formatDate(item.start_date)} - ${formatDate(item.end_date)}`}
                                                </p>
                                                {Number(item.price_from) > 0 && (
                                                    <p className="event-list-price">
                                                        {item.price_to != null && <span>From </span>}
                                                        <span>AED {item.price_from}</span>
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </Link>
                                ))
                            ) : (
                                <div className="nodata-message-categorylist">
                                    <img src={nodata} alt="no data" className="no-data-img" />
                                    <p className="no-data-p1">No events found</p>
                                    <p className="no-data-p2">Come back later to explore</p>
                                </div>
                            );
                        })()}
                    </div>
                </main>
            </div>


            {/* Country pop up */}
            {countrypopup && (
                <>
                    {/* Overlay */}
                    <div className="custom-overlay" onClick={() => setCountrypopup(false)}></div>

                    {/* Centered Popup */}
                    <div className="custom-popup">
                        <div className="custom-popup-header">
                            <h4>Choose Your Location</h4>
                            <img src={xmark} alt="close" className="close-popup" onClick={() => setCountrypopup(false)} />
                        </div>

                        {/* States List */}
                        <div className="custom-popup-body">
                            <div className="state-grid">
                                {states.filter((state) => Number(state.country_id) === 1)
                                    .map((state, index, arr) => {
                                        const isDisabled = index >= arr.length - 4; // last 4 items

                                        return (
                                            <div
                                                key={state.id}
                                                className={`state-item ${isDisabled ? "disabled" : ""}`}
                                                onClick={() => !isDisabled && handleStateClick(state)}
                                            >
                                                <img
                                                    src={index < 2 ? flagicon : countryicons[index - 2]}
                                                    alt="flag"
                                                    className="flagicon-popup"
                                                />
                                                <p>{state.name}</p>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                </>
            )}

            {/* Download Popup for Following */}
            {showDownloadPopup && (
                <>
                    <div className="overlay" onClick={() => setShowDownloadPopup(false)}></div>
                    <div className="download-popup-drawer">
                        <div className="pop-up-img">
                            <img src={popup_yatch} alt="pop up yatch" className="pop-up-yatch" />
                        </div>
                        <div className="popup-header">
                            <div className="pop-up-download">
                                <div className="hayaticon">
                                    <img src={hayatlogo} alt="Hayat In Logo" />
                                    <div className="close-btn">
                                        <img src={xmark} alt="xmark" className="close-popup" onClick={() => setShowDownloadPopup(false)} />
                                    </div>
                                </div>
                                <h4 className="download-hayat">Download Our App </h4>
                                <p id="App-description">
                                    Scan the QR code with your phone and open Hayat In instantly
                                    Your gateway to discovering the city in one tap.
                                </p>

                                <div className="store-buttons">
                                    <div className="app_qr">
                                        <a
                                            href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={app_store} alt="App Store" />
                                        </a>

                                        <a
                                            href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={play_store} alt="Google Play" />
                                        </a>
                                    </div>

                                    <div className="app_qr">
                                        <img className="qr" src={qr} alt="QR code" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {filtepopup && (
                <>
                    <div className="overlay" onClick={() => setFilterpopup(false)}></div>
                    <div className="popup-drawer popup-drawer-event-category">
                        <div className="popup-header">
                            <h4></h4>
                            <img src={xmark} alt="xmark" className="close-popup" onClick={() => setFilterpopup(false)} />
                        </div>

                        <div className="filter-list">

                            {/* Event Category Section */}
                            <div className="filter-section">
                                <div className="filter-header" onClick={toggleEventCategories}>
                                    <h6 className="filter-title eventcat-list">
                                        {eventcategoryId && urlType !== 'events' && urlType !== 'categorybanner' ? 'Subcategories' : 'Event Category'}
                                    </h6>
                                    <img src={downarrowicon} alt="down arrow" className={`sub-down-arrow-icon ${showEventCategories ? "rotate" : ""}`} />
                                </div>
                                {showEventCategories && (
                                    <div className="filter-checkbox-list">
                                        {(() => {
                                            // If eventcategoryId exists and it's not a banner type, show only subcategories of that category
                                            if (eventcategoryId && urlType !== 'events' && urlType !== 'categorybanner') {
                                                // Find the selected category
                                                const selectedCategory = eventcategory.find(
                                                    cat => Number(cat.id) === Number(eventcategoryId)
                                                );

                                                if (selectedCategory && Array.isArray(selectedCategory.subcategories) && selectedCategory.subcategories.length > 0) {
                                                    // Show only subcategories
                                                    return selectedCategory.subcategories.map((sub) => (
                                                        <label key={sub.id} className="filter-checkbox-item subcategory-item">
                                                            <input
                                                                type="checkbox"
                                                                value={sub.id}
                                                                checked={selectedSubcategories.includes(Number(sub.id))}
                                                                onChange={(e) => handleSubcategoryChange(e, sub.id)}
                                                            />
                                                            {sub.category_name}
                                                        </label>
                                                    ));
                                                } else {
                                                    return <div style={{ padding: '10px', color: '#999' }}>No subcategories available</div>;
                                                }
                                            } else {
                                                // Show all categories with their subcategories (All Events view)
                                                if (Array.isArray(eventcategory) && eventcategory.length > 0) {
                                                    return eventcategory.map((category) => {
                                                        const hasSubcategories = Array.isArray(category.subcategories) && category.subcategories.length > 0;
                                                        const isExpanded = expandedCategories[category.id];
                                                        const isSelected = selectedCategories.includes(Number(category.id));

                                                        return (
                                                            <div key={category.id} className="category-item-wrapper">
                                                                <label className="filter-checkbox-item category-item">
                                                                    <input
                                                                        type="checkbox"
                                                                        value={category.id}
                                                                        checked={isSelected}
                                                                        onChange={(e) => handleCategoryChange(e, category.id)}
                                                                    />
                                                                    <span className="category-name">{category.category_name}</span>
                                                                    {hasSubcategories && (
                                                                        <span
                                                                            className="category-expand-icon"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                toggleCategoryExpansion(category.id);
                                                                            }}
                                                                        >
                                                                            {isExpanded ? '−' : '+'}
                                                                        </span>
                                                                    )}
                                                                </label>
                                                                {hasSubcategories && isExpanded && (
                                                                    <div className="subcategories-list">
                                                                        {category.subcategories.map((sub) => (
                                                                            <label key={sub.id} className="filter-checkbox-item subcategory-item">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    value={sub.id}
                                                                                    checked={selectedSubcategories.includes(Number(sub.id))}
                                                                                    onChange={(e) => handleSubcategoryChange(e, sub.id)}
                                                                                />
                                                                                {sub.category_name}
                                                                            </label>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    });
                                                } else {
                                                    return <div style={{ padding: '10px', color: '#999' }}>No categories available</div>;
                                                }
                                            }
                                        })()}
                                    </div>
                                )}
                            </div>

                            {/* Date Filters - Mobile/Tablet (320px-992px) */}
                            <div className="filter-section mobile-date-filter-section">
                                <div className="filter-header" onClick={toggleDateFilters}>
                                    <h6 className="filter-title">Date</h6>
                                    <img src={downarrowicon} alt="down arrow" className={`sub-down-arrow-icon ${showDateFilters ? "rotate" : ""}`} />
                                </div>
                                {showDateFilters && (
                                    <div className="filter-date-content">
                                        <div className="event-date-filters mobile-date-filters">
                                            <p className="start-end-date">Start Date</p>
                                            <div className="date-input-wrapper">
                                                <img src={datepicker} alt="date selector" className="datepicker" />
                                                <input
                                                    type="date"
                                                    className="date-input"
                                                    value={startDate}
                                                    onChange={handleStartDateChange}
                                                />
                                                {!startDate && <span className="date-placeholder">DD/MM/YYYY</span>}
                                            </div>
                                            <span>- </span>
                                            <p className="start-end-date">End Date</p>
                                            <div className="date-input-wrapper">
                                                <img src={datepicker} alt="date selector" className="datepicker" />
                                                <input
                                                    ref={endDateInputRef}
                                                    type="date"
                                                    className="date-input"
                                                    value={endDate}
                                                    onChange={handleEndDateChange}
                                                />
                                                {!endDate && <span className="date-placeholder">DD/MM/YYYY</span>}
                                            </div>
                                            {(startDate || endDate) && (
                                                <button className="clear-date-btn" onClick={handleClearDates}>
                                                    Clear
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Event Type */}
                            <div className="filter-section">
                                <div className="filter-header" onClick={toggleEventTypes}>
                                    <h6 className="filter-title eventcat-list">Event Type</h6>
                                    <img src={downarrowicon} alt="down arrow" className={`sub-down-arrow-icon ${showEventTypes ? "rotate" : ""}`} />
                                </div>
                                {showEventTypes && (
                                    <div className="filter-checkbox-list">
                                        <label className="filter-checkbox-item">
                                            <input
                                                type="checkbox"
                                                value="0"
                                                checked={selectedEventTypes.includes(0)}
                                                onChange={(e) => handleEventTypeChange(e, 0)}
                                            />
                                            Free
                                        </label>
                                        <label className="filter-checkbox-item">
                                            <input
                                                type="checkbox"
                                                value="1"
                                                checked={selectedEventTypes.includes(1)}
                                                onChange={(e) => handleEventTypeChange(e, 1)}
                                            />
                                            Ticketed
                                        </label>
                                    </div>
                                )}
                            </div>

                            <div className="filter-buttons">
                                <button className="clear-btn" onClick={handleClearAll}>Clear All</button>
                                <button className="show-btn" onClick={handleShowResult}>Show Result</button>
                            </div>

                        </div>
                    </div>
                </>
            )}
        </div>
    )
}


export default EventCategoryList;